import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const Approval = types
  .model({
    businessNumber: types.maybeNull(types.string),
    businessDate: types.maybeNull(types.string),
    businessExpiredDate: types.maybeNull(types.string),
    printDate: types.maybeNull(types.string),
    printNumber: types.maybeNull(types.string),
    printExpiredDate: types.maybeNull(types.string),
    customerRequest: types.maybeNull(types.string),
  })
  .actions(withSetPropAction);
export interface IApproval extends Instance<typeof Approval> {}
export interface IApprovalProperties extends SnapshotIn<typeof Approval> {}

export interface IUpdateApproval extends IApprovalProperties {}
